<template>
  <div class="site-legal-content" v-if="company">
    <div class="site-legal-content__wrapper">
      <p>
        <strong>Identité et coordonnées de l'organisme responsable du traitement informatique des donnéespersonnelles :</strong><br><br>
        <template v-if="company">
          <strong>{{ company.name }}</strong><br />
          <strong>{{ company.legal }}</strong><br />
          <strong v-for="line in company.address" :key="line">{{ line }} <br /></strong>
          <strong>{{ company.siret }}</strong><br />
        </template>
      </p>
      <p><strong>Finalité poursuivie par le traitement :</strong> Les données ne sont collectées par la société que pour servir l'objectif du produit (gestion administrative de société du client), ainsi que pour des besoins légaux (facturation).</p>
      <p><strong>Caractère obligatoire ou facultatif du recueil de données personnelles :</strong> La collecte de données proposée par CRA Freelance est essentielle au bon fonctionnement du produit ainsi qu'au respect des obligations comptables. L'absence de fourniture de ces données entraine une impossibilité de fournir le service.</p>
      <p><strong>Destinataires des données personnelles :</strong> Les mandataires et certains employés de la société {{ company.name }} sont habilités à accéder à la totalité des données, afin d'en contrôler la véracité, la coherence, de les corriger si nécessaire.</p>
      <p><strong>Durée de conservation des données personnelles :</strong> Les données non nécessaires au respect des obligation comptables sont supprimées trois ans après la résiliation du service, sauf demande explicite. Les autres données sont supprimées au bout de huit ans.</p>
      <p><strong>Droits de l'internaute :</strong> le droit de refuser la collecte, le droit d'accéder, de rectifier et d'effacer ses données, introduire une réclamation auprès de la Cnil.</p>
      <p><strong></strong>Les données sont stockées sur des serveurs en dehors de l'Union Européenne.</p>
    </div>
  </div>
</template>

<script setup>
  const config = useRuntimeConfig()
  const company = await $fetch(`${config.public.apiBaseUrl}/legal`)
</script>

<style lang="scss">

  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  .site-legal-content {
    display: flex;
    justify-content: center;
    font-weight: 200;
    font-size: 18px;
    color: #242424;

    a {
      color: #407BFF;
    }
  
    &__wrapper {
      flex-grow: 1;
      max-width: 1200px;
      padding: 0 15px;
      margin-bottom: 50px;

      @media screen and (min-width: $tablet-breakpoint) {
        padding: 0 30px;
        margin-bottom: 100px;
      }

      &__intro {
        font-weight: 300;
        font-size: 26px;
      }

      &__title {
        font-size: 26px;
        font-weight: 600;
        margin-top: 50px;
      }
    }
  }
</style>